import { updateRUMGlobalContext } from 'src/helpers/MetricsContext';

import { startAppListening } from '../middleware';

startAppListening({
  type: 'gql/executeQuery/fulfilled',
  effect: async (action, listenerApi) => {
    //TODO - this a temp listener for setting the rum global context on load of sellerInputs
    //This should be moved to flowLoader when it is refactored.
    //@ts-expect-error - todo - fix this type
    if (action.meta?.arg?.endpointName === 'getSellerInputs') {
      const state = listenerApi.getState();

      updateRUMGlobalContext({
        market: state.sellerInput.market,
        featureFlags: state?.featureFlags,
        experiments: state?.experimentFlags,
        denialCode: state.sellerInput.denialCode,
        denialReasons: state.sellerInput.denialReason,
        sellerInputUUID: state.sellerInput.leadToken,
        addressUuid: state.sellerInput.address.uuid,
        customerUuid: state.sellerInput.customerUUID,
        hasPartnershipReferral: state.sellerInput.partnerships
          ? state.sellerInput.partnerships.length > 0
          : false,
        productOfferings: state.sellerInput.productOfferings,
        state: state.sellerInput.leadState,
      });
    }
  },
});
